import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { CreateShipmentPayload } from '~/api/resolution-engine/types/CreateShipment.types'

export const useCreateShipmentApi = (body: CreateShipmentPayload) => {
  const $httpFetch = useHttpFetch()

  return $httpFetch('/resolution-engine/shipments', {
    method: 'POST',
    body,
  })
}
